import React from "react";
import HeaderTree from "./headerTree"

export default ({ topSlot, bottomSlot, children, page, related }) => {

  return (
    <main className="cd-body">

      <div className="cd-content" id="content">
        {children}
      </div>

      <HeaderTree page={page} related={related} />

    </main>
  )

}
